import api from './api';

/**
 * Driver Pay - Open Legs "Clear Leg" action. The grid + read-only drawer go
 * through the generic /tablemaint engine (key 'driverpay-open-legs'); this is the
 * one mutation — it blanks the pay/approval/rate fields on a driverpay_lineitem row
 * (V1 editdriverpay_lineitem Clear Leg) so the driver-pay process re-rates the leg.
 */
export async function clearOpenLeg(recno: number): Promise<void> {
  await api.post(`/driverpay/open-legs/${recno}/clear-leg`);
}
